import { createReducer } from '@reduxjs/toolkit'
import { FeeAmount } from '@uniswap/v3-sdk'

import { setCurrenciesAmountsAndWlpAction, setSelectedFeeAction } from './actions'
import { ISetCurrencyAmountPayload } from './types'

export enum Fields {
  CURRENCY_A = 'CURRENCY_A',
  CURRENCY_B = 'CURRENCY_B',
}
export type FieldType = keyof typeof Fields
export type ChartFeeType = FeeAmount | 'ALL'
export interface IState {
  selectedFeeAmount: ChartFeeType
  currencyAValue?: string
  currencyBValue?: string
  wlpValue?: string
}

const initialState: IState = {
  currencyAValue: '0',
  currencyBValue: '0',
  wlpValue: '0',
  selectedFeeAmount: 'ALL',
}

export default createReducer<IState>(initialState, (builder) => {
  return builder
    .addCase(setCurrenciesAmountsAndWlpAction, (state, { payload }) => {
      const { currencyAValue, currencyBValue, wlpValue }: ISetCurrencyAmountPayload = payload
      return {
        ...state,
        currencyAValue,
        currencyBValue,
        wlpValue,
      }
    })
    .addCase(setSelectedFeeAction, (state, { payload }) => {
      return {
        ...state,
        selectedFeeAmount: payload,
      }
    })
})
